exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auth-form{width:480px;max-width:100%;margin:25vh auto 15px;padding:15px;background:#fff;border-radius:2px;box-shadow:0 1px 5px #ccc}.auth-form h1{font-weight:300}.auth-form>div{margin-top:15px}.auth-form input{height:32px;border:0;border-bottom:2px solid #bbb}.auth-form input:focus{border-bottom-color:#555}.auth-form input,.auth-form label{display:block;width:100%}.auth-form button{margin:0;padding:4px 6px;border:1px solid #41b883;border-radius:3px;font-size:18px;background:#fff}.auth-form .btn-group button{float:left;width:50%;border-radius:3px 0 0 3px}.auth-form .btn-group button+button{border-left:0;border-radius:0 3px 3px 0}.auth-form .signup-submit{width:100%}.auth-form hr{margin-top:20px}.auth-form a{color:#41b883;font-weight:700}.auth-form .social-providers{text-align:center}.auth-form .social-providers a{padding:4px;font-size:36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/pages/Login.scss
// module id = 132
// module chunks = 0